var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardNoErrorCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#EDEDF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.0121 31H47.9879L31 47.9879V72.0121L47.9879 89H72.0121L89 72.0121V47.9879L72.0121 31ZM62.664 74.5996H57.336V68.387H62.664V74.5996ZM62.664 66.3158H57.336V45.3998H62.664V66.3158Z",
    fill: "#C1C6D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardNoErrorCode);
export default __webpack_public_path__ + "static/media/dashboard_no_error_code.6033c62d07bb52500b8a71b095389575.svg";
export { ForwardRef as ReactComponent };